import { Box, Stack } from "@mui/material";

import { CarrierUpgradeNowButton } from "components/Carrier/components/CarrierUpgradeNowButton";
import { CarrierUpgradeSource } from "constants/index";
import { useSubscriptionStatus } from "hooks";
import { useIsMobile } from "hooks/useIsMobile";

import { CarrierPayPerBookingCenterBannerText } from "../CarrierPayPerBookingCenterBannerText";
import { CarrierEssentialsBookingRemainingBannerText } from "../CarrrierEssentialsBookingsRemaining";

export function FreeCarrierBanner() {
  const { subscription } = useSubscriptionStatus();
  const screenBigEnoughForRemainingBookings = !useIsMobile({ maxWidth: 950 });

  // CARRIER_ESSENTIALS_V2 carriers have no non-partner booking count to surface,
  // so no center banner text is shown for them — only the upgrade CTA.
  const plan = subscription?.subscription_plan;
  let centerBannerText: React.ReactNode = null;
  if (plan === "CARRIER_ESSENTIALS") {
    centerBannerText = <CarrierEssentialsBookingRemainingBannerText />;
  } else if (plan === "CARRIER_PAY_PER_BOOKING") {
    centerBannerText = <CarrierPayPerBookingCenterBannerText />;
  }

  return (
    <Stack direction="row" spacing={4} alignItems="center">
      {screenBigEnoughForRemainingBookings && centerBannerText && (
        <Box>{centerBannerText}</Box>
      )}
      <CarrierUpgradeNowButton
        upgradeSource={CarrierUpgradeSource.FREE_CARRIER_BANNER}
      />
    </Stack>
  );
}
